import React, { useState } from 'react';
import Footer from '../../layout/Footer';
import { Container, Row, Col, Card } from 'react-bootstrap';

import GeneralLedgerTableData from "./general-ledger-table-data.json";
import TableElement from '../../../Utils/elements/TableElement';

export default function GeneralLedger() {
    const [generalLedgerData] = useState(GeneralLedgerTableData);

    

    // Cash Debits Table
    const acReortsGLCashDebits = {
        tableClass: 'table-nowrap mb-xl-0',
        thead: ['Date', 'Perticular', 'Debits(Dr.)'],
        tbody: generalLedgerData.Cashdebitdata.map((item) => ({
            date: { type: 'text', text: item.date },
            perticular: { type: 'text', text: item.perticular },
            debitsdr: { type: 'text', text: item.debits },
        }))
    };

    // Cash Credits Table
    const acReortsGLCashCredit = {
        tableClass: 'table-nowrap mb-0',
        thead: ['Date', 'Perticular', 'Credit(Dr.)'],
        tbody: generalLedgerData.Cashcreditdata.map((item) => ({
            date: { type: 'text', text: item.date },
            perticular: { type: 'text', text: item.perticular },
            creditdr: { type: 'text', text: item.credit },
        }))
    };

    // Bank Debits Table
    const acReortsGLBankDebits = {
        tableClass: 'table-nowrap mb-xl-0',
        thead: ['Date', 'Perticular', 'Debits(Dr.)'],
        tbody: generalLedgerData.Bankdebitdata.map((item) => ({
            date: { type: 'text', text: item.date },
            perticular: { type: 'text', text: item.perticular },
            debitsdr: { type: 'text', text: item.debits },
        }))
    };

    // Bank Credits Table
    const acReortsGLBankCredit = {
        tableClass: 'table-nowrap mb-0',
        thead: ['Date', 'Perticular', 'Credit(Dr.)'],
        tbody: generalLedgerData.Bankcreditdata.map((item) => ({
            date: { type: 'text', text: item.date },
            perticular: { type: 'text', text: item.perticular },
            creditdr: { type: 'text', text: item.credit },
        }))
    };

    // Tax Debits Table
    const acReortsGLTaxDebits = {
        tableClass: 'table-nowrap mb-xl-0',
        thead: ['Date', 'Perticular', 'Debits(Dr.)'],
        tbody: generalLedgerData.Taxdebitdata.map((item) => ({
            date: { type: 'text', text: item.date },
            perticular: { type: 'text', text: item.perticular },
            debitsdr: { type: 'text', text: item.debits },
        })),
        tfoot: ['30-11-2022', 'Closing balance', '104800.01']
    };

    // Tax Credits Table
    const acReortsGLTaxCredit = {
        tableClass: 'table-nowrap mb-0',
        thead: ['Date', 'Perticular', 'Credit(Dr.)'],
        tbody: generalLedgerData.Taxcreditdata.map((item) => ({
            date: { type: 'text', text: item.date },
            perticular: { type: 'text', text: item.perticular },
            creditdr: { type: 'text', text: item.credit },
        }))
    };

    // Product Debits Table
    const acReortsGLProductDebits = {
        tableClass: 'table-nowrap mb-xl-0',
        thead: ['Date', 'Perticular', 'Debits(Dr.)'],
        tbody: generalLedgerData.Productdebitdata.map((item) => ({
            date: { type: 'text', text: item.date },
            perticular: { type: 'text', text: item.perticular },
            debitsdr: { type: 'text', text: item.debits },
        })),
        tfoot: ['30-11-2022', 'Closing balance', '822054.40']
    };

    // Product Credits Table
    const acReortsGLProductCredit = {
        tableClass: 'table-nowrap mb-0',
        thead: ['Date', 'Perticular', 'Credit(Dr.)'],
        tbody: generalLedgerData.Productcreditdata.map((item) => ({
            date: { type: 'text', text: item.date },
            perticular: { type: 'text', text: item.perticular },
            creditdr: { type: 'text', text: item.credit },
        }))
    };

    // Inventory Debits Table
    const acReortsGLInventoryDebits = {
        tableClass: 'table-nowrap mb-xl-0',
        thead: ['Date', 'Perticular', 'Debits(Dr.)'],
        tbody: generalLedgerData.Inventorydebitdata.map((item) => ({
            date: { type: 'text', text: item.date },
            perticular: { type: 'text', text: item.perticular },
            debitsdr: { type: 'text', text: item.debits },
        })),
    };

    // Inventory Credits Table
    const acReortsGLInventoryCredit = {
        tableClass: 'table-nowrap mb-0',
        thead: ['Date', 'Perticular', 'Credit(Dr.)'],
        tbody: generalLedgerData.Inventorycreditdata.map((item) => ({
            date: { type: 'text', text: item.date },
            perticular: { type: 'text', text: item.perticular },
            creditdr: { type: 'text', text: item.credit },
        })),
        tfoot: ['30-11-2022', 'Closing balance', '404855575.84']
    };

    // Discount Debits Table
    const acReortsGLDiscountDebits = {
        tableClass: 'table-nowrap mb-xl-0',
        thead: ['Date', 'Perticular', 'Debits(Dr.)'],
        tbody: generalLedgerData.Discountdebitdata.map((item) => ({
            date: { type: 'text', text: item.date },
            perticular: { type: 'text', text: item.perticular },
            debitsdr: { type: 'text', text: item.debits },
        })),
    };

    // Discount Credits Table
    const acReortsGLDiscountCredit = {
        tableClass: 'table-nowrap mb-0',
        thead: ['Date', 'Perticular', 'Credit(Dr.)'],
        tbody: generalLedgerData.Discountcreditdata.map((item) => ({
            date: { type: 'text', text: item.date },
            perticular: { type: 'text', text: item.perticular },
            creditdr: { type: 'text', text: item.credit },
        })),
        tfoot: ['30-11-2022', 'Closing balance', '17112.14']
    };

    // AcPayable Debits Table
    const acReortsGLAcPayableDebits = {
        tableClass: 'table-nowrap mb-xl-0',
        thead: ['Date', 'Perticular', 'Debits(Dr.)'],
        tbody: generalLedgerData.Apdebitdata.map((item) => ({
            date: { type: 'text', text: item.date },
            perticular: { type: 'text', text: item.perticular },
            debitsdr: { type: 'text', text: item.debits },
        })),
        tfoot: ['30-11-2022', 'Closing balance', '356.00']
    };

    // AcPayable Credits Table
    const acReortsGLAcPayableCredit = {
        tableClass: 'table-nowrap mb-0',
        thead: ['Date', 'Perticular', 'Credit(Dr.)'],
        tbody: generalLedgerData.Apcreditdata.map((item) => ({
            date: { type: 'text', text: item.date },
            perticular: { type: 'text', text: item.perticular },
            creditdr: { type: 'text', text: item.credit },
        })),
    };

    // Cost Of Goods Sold Debits Table
    const acReortsGLCOGSDebits = {
        tableClass: 'table-nowrap mb-xl-0',
        thead: ['Date', 'Perticular', 'Debits(Dr.)'],
        tbody: generalLedgerData.Cogsdebitdata.map((item) => ({
            date: { type: 'text', text: item.date },
            perticular: { type: 'text', text: item.perticular },
            debitsdr: { type: 'text', text: item.debits },
        })),
    };

    // Cost Of Goods Sold Credits Table
    const acReortsGLCOGSCredit = {
        tableClass: 'table-nowrap mb-0',
        thead: ['Date', 'Perticular', 'Credit(Dr.)'],
        tbody: generalLedgerData.Cogscreditdata.map((item) => ({
            date: { type: 'text', text: item.date },
            perticular: { type: 'text', text: item.perticular },
            creditdr: { type: 'text', text: item.credit },
        })),
        tfoot: ['30-11-2022', 'Closing balance', '681140.82']
    };

    // Round Off Debits Table
    const acReortsGLRoundOffDebits = {
        tableClass: 'table-nowrap mb-0',
        thead: ['Date', 'Perticular', 'Debits(Dr.)'],
        tbody: generalLedgerData.Roundoffdebitdata.map((item) => ({
            date: { type: 'text', text: item.date },
            perticular: { type: 'text', text: item.perticular },
            debitsdr: { type: 'text', text: item.debits },
        })),
        tfoot: ['30-11-2022', 'Closing balance', '0.56']
    };

    // Round Off Credits Table
    const acReortsGLRoundOffCredit = {
        tableClass: 'table-nowrap mb-0',
        thead: ['Date', 'Perticular', 'Credit(Dr.)'],
        tbody: generalLedgerData.Roundoffcreditdata.map((item) => ({
            date: { type: 'text', text: item.date },
            perticular: { type: 'text', text: item.perticular },
            creditdr: { type: 'text', text: item.credit },
        })),
    };

    // Sections
    const sections = [
        {
            title: 'Cash',
            data: [{ table: acReortsGLCashDebits, colSize: 6 }, { table: acReortsGLCashCredit, colSize: 6 },],
        },
        {
            title: 'Bank',
            data: [{ table: acReortsGLBankDebits, colSize: 6 }, { table: acReortsGLBankCredit, colSize: 6 },],
        },
        {
            title: 'Tax',
            data: [{ table: acReortsGLTaxDebits, colSize: 6 }, { table: acReortsGLTaxCredit, colSize: 6 },],
        },
        {
            title: 'Product',
            data: [{ table: acReortsGLProductDebits, colSize: 6 }, { table: acReortsGLProductCredit, colSize: 6 },],
        },
        {
            title: 'Inventory',
            data: [{ table: acReortsGLInventoryDebits, colSize: 6 }, { table: acReortsGLInventoryCredit, colSize: 6 },],
        },
        {
            title: 'Discount',
            data: [{ table: acReortsGLDiscountDebits, colSize: 6 }, { table: acReortsGLDiscountCredit, colSize: 6 },],
        },
        {
            title: 'Accounts Payable (A/P)',
            data: [{ table: acReortsGLAcPayableDebits, colSize: 6 }, { table: acReortsGLAcPayableCredit, colSize: 6 },],
        },
        {
            title: 'Cost Of Goods Sold',
            data: [{ table: acReortsGLCOGSDebits, colSize: 6 }, { table: acReortsGLCOGSCredit, colSize: 6 },],
        },
        {
            title: 'Round Off',
            data: [{ table: acReortsGLRoundOffDebits, colSize: 6 }, { table: acReortsGLRoundOffCredit, colSize: 6 },],
        },
    ];

    return (
        <>
            <div className="page-wrapper">
                <div className='page-content'>
                    <Container>
                        {sections.map((section, index) => (
                            <Row key={index}>
                                <Col>
                                    <Card>
                                        <Card.Body>
                                            <Card.Title>{section.title}</Card.Title>
                                            <Row>
                                                {section.data.map((col, colIndex) => (
                                                    <Col xl={col.colSize} key={colIndex}>
                                                        <TableElement tableClass={col.table.tableClass} thead={col.table.thead} tbodydata={col.table.tbody} tfootdata={col.table.tfoot || null} />
                                                    </Col>
                                                ))}
                                            </Row>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row>
                        ))}
                    </Container>
                </div>
                <Footer />
            </div>
        </>
    )
}
